import type { DateValue } from '@ark-ui/react';
import { getISOWeek, getISOWeekYear } from 'date-fns';

export function getIsoWeek(date: DateValue): string {
  // Clone the date to avoid mutating the original
  const target = new Date(date.toString());
  // ISO week date weeks start on Monday, so adjust accordingly
  const weekNumber = getISOWeek(target);
  return weekNumber.toString().padStart(2, '0');
}

export function getCalendarWeek(date: Date): string {
  const isoYear = getISOWeekYear(date);
  const week = getISOWeek(date);
  return `${isoYear} CW${week.toString().padStart(2, '0')}`;
}
